import React from "react";
import { useTranslation } from "react-i18next";
import { BaseModal, IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import styles from "./AskTuvisAccountManagerToConnectModal.module.scss";
import { observer } from "mobx-react-lite";
import { Text } from "@whatslly/ui-components/Text";

export const AskTuvisAccountManagerToConnectModal: React.FC<IModalInstance> = observer(({ closeModal }) => {
  const { t } = useTranslation();
  return (
    <BaseModal
      closeOnClickOutside={true}
      closeOnEscape={true}
      header={
        <ModalHeader closeModal={closeModal}>
          <Text>{t("twilio_settings_page.connect_to_tuvis_call_recording_modal.title")}</Text>
        </ModalHeader>
      }
      closeModal={() => closeModal()}
      className={styles.modal}
      bodyClassName={styles.modalBody}
    >
      <div className={styles.modalContent}>
        <Text>{t("twilio_settings_page.connect_to_tuvis_call_recording_modal.description")}</Text>
      </div>
    </BaseModal>
  );
});
